import React from "react";
import { Grid, Paper } from "@mui/material";
import { withStyles } from "@mui/styles";
import EventSystemForm from "./EventSystemForm";
import RevaText from "components/common/RevaText";
import { ROUTES } from "constants/routes";

const styles = (theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  formContainer: {
    padding: theme.spacing(4),
  },
});

const CreateClassificationEvent = (props) => {
  const { classes, location } = props;
  const eventSystem = location.state?.eventSystem;

  return (
    <Grid container className={classes.container} xs={4}>
      <Paper className={classes.formContainer}>
        <Grid item xs={12}>
          <RevaText variant="h1" className={classes.title}>
            {eventSystem ? "Editar" : "Nuevo"} evento de clasificación
          </RevaText>
        </Grid>
        <Grid container item xs={12}>
          <EventSystemForm
            {...props}
            eventSystem={eventSystem}
            onSubmitResponse={() => {
              props.history.push(`${ROUTES.ADMIN.ORGANIZATIONS}/classification-events`);
            }}
          />
        </Grid>
      </Paper>
    </Grid>
  );
};

export default withStyles(styles)(CreateClassificationEvent);
